<template>
    <div class="historylist">
      <img @click="goBack()" :src="require('../../../assets/images/powderedMilk/hisback.png')" class="goback" alt=''/>
      <history></history>
    </div>
  </template>
  <script>
  import history from "@/components/contents/powderedMilk/history/index.vue"; //引入历史组件
  export default{
    name:'historylist',
    data(){
      return{

      }
    },
    computed:{

    },
    watch:{

    },
    created(){
    },
    methods:{
      goBack(){
      if(window.history.length > 1){
        this.$router.go(-1);
      }else{
        this.$router.push("/home")
      }
    },
    },
    components: {
      history
  },
  }
  </script>
  <style lang="less" scoped>
  .historylist{
    width: 100%;
    min-height: 100%;

    padding: 39px 16px 56px 16px;
    box-sizing: border-box;
    position: relative;
    background: linear-gradient(2deg, #FFFFFF 0%, #F8F8FA 40%, #7863EA 100%);
  }
  .goback{
    width: 24px;
    height: 24px;
    position: absolute;
    top: 8px;
  }
  </style>
